// Kandake Iron Gate — controlled taxonomy labels + badge helpers.
// Keep in lock-step with /app/backend/ai_provenance.py enums.

export const COMPOSITION_ORIGIN = ["HUMAN_CREATED","AI_ASSISTED","AI_GENERATED","UNKNOWN"];
export const RECORDING_ORIGIN   = ["HUMAN_PERFORMED","AI_ASSISTED","AI_GENERATED","UNKNOWN"];
export const FINAL_AUDIO_AI_PRESENCE = ["NONE_VERIFIED","NONE_DECLARED","PARTIAL","PRIMARY","UNKNOWN"];
export const TECHNICAL_AI_USE = ["NONE_DECLARED","PRESENT","UNKNOWN"];
export const AI_DEV_HISTORY_TAGS = [
  "NO_AI_HISTORY_DECLARED","AI_IDEATION","AI_DEMO_RENDERING","AI_LYRICS","AI_MELODY",
  "AI_HARMONY","AI_ARRANGEMENT","AI_LEAD_VOCAL","AI_BACKGROUND_VOCALS",
  "AI_INSTRUMENTAL_PERFORMANCE","AI_GENERATED_STEMS","AI_VOICE_CONVERSION",
  "AI_MIXING","AI_MASTERING","AI_SOURCE_SEPARATION","OTHER_AI_USE","UNKNOWN_AI_HISTORY",
];
export const EVIDENCE_CATEGORY = [
  "DAW_SESSION","STEMS","RAW_VOCAL_FILES","RAW_INSTRUMENT_FILES","SESSION_LOG",
  "STUDIO_INVOICE","MUSICIAN_CONFIRMATION","VOCALIST_CONFIRMATION",
  "WRITER_CONFIRMATION","PRODUCER_CONFIRMATION","CONTRACT","LICENCE",
  "VOICE_CONSENT","AI_PLATFORM_HISTORY","PROMPT_HISTORY","FILE_METADATA",
  "COPYRIGHT_RECORD","RELEASE_CREDITS","OTHER",
];
export const BUYER_POLICY_MODES = [
  "STRICT_NO_AI_ANY_STAGE","HUMAN_FINAL_ALLOWED_AI_HISTORY","AI_ASSISTED_ALLOWED",
  "AI_GENERATED_ALLOWED","CASE_BY_CASE","UNKNOWN",
];
export const DECLARANT_CAPACITY = [
  "CREATOR_WRITER","CREATOR_PRODUCER","PERFORMER_LEAD","PERFORMER_BAND",
  "LABEL_REP","PUBLISHER_REP","MANAGER","CATALOG_MANAGER","OTHER",
];
export const ROUTING_CLASSES = [
  "NO_AI_HISTORY_VERIFIED","HUMAN_FINAL_WITH_AI_DEVELOPMENT_HISTORY",
  "AI_ASSISTED","AI_GENERATED","UNKNOWN","CONFLICTED","STALE",
];
export const ADJUDICATION_STATUSES = [
  "UNREVIEWED","DECLARATION_PENDING","SCREENING_PENDING","EVIDENCE_PENDING",
  "UNDER_REVIEW","VERIFIED","INCONCLUSIVE","CONFLICTED","STALE","ARCHIVED",
];

export const ROUTING_LABELS = {
  NO_AI_HISTORY_VERIFIED:                 "VERIFIED NO AI HISTORY",
  HUMAN_FINAL_WITH_AI_DEVELOPMENT_HISTORY: "HUMAN FINAL / AI DEVELOPMENT HISTORY",
  AI_ASSISTED: "AI-ASSISTED",
  AI_GENERATED: "AI-GENERATED",
  UNKNOWN: "UNKNOWN",
  CONFLICTED: "CONFLICTED",
  STALE: "STALE",
};

export const SYNC_GATE_LABELS = {
  OPEN: "SYNC OPEN",
  BLOCKED: "SYNC BLOCKED",
  DISCLOSURE_REQUIRED: "DISCLOSURE REQUIRED",
  REVIEW_REQUIRED: "REVIEW REQUIRED",
};

export const SCREENING_PENDING_MESSAGE = "SCREENING PENDING: DETECTION PROVIDER NOT CONFIGURED";

export function routingBadgeStyle(cls) {
  // Distinct, readable, colour-and-text pairs. Follows Kandake tokens.
  switch ((cls || "UNKNOWN").toUpperCase()) {
    case "NO_AI_HISTORY_VERIFIED":                 return { background: "hsl(140 40% 92%)", color: "hsl(140 55% 22%)", border: "hsl(140 40% 75%)" };
    case "HUMAN_FINAL_WITH_AI_DEVELOPMENT_HISTORY": return { background: "hsl(40 48% 92%)",  color: "hsl(347 72% 22%)", border: "hsl(40 48% 78%)" };
    case "AI_ASSISTED":                            return { background: "hsl(30 60% 92%)",  color: "hsl(30 60% 30%)",  border: "hsl(30 60% 78%)" };
    case "AI_GENERATED":                           return { background: "hsl(0 60% 94%)",   color: "hsl(0 60% 30%)",   border: "hsl(0 60% 78%)" };
    case "UNKNOWN":                                return { background: "hsl(210 10% 92%)", color: "hsl(210 10% 30%)", border: "hsl(210 10% 75%)" };
    case "CONFLICTED":                             return { background: "hsl(340 60% 94%)", color: "hsl(340 60% 30%)", border: "hsl(340 60% 78%)" };
    case "STALE":                                  return { background: "hsl(260 20% 94%)", color: "hsl(260 40% 30%)", border: "hsl(260 20% 75%)" };
    default:                                       return { background: "hsl(210 10% 92%)", color: "hsl(210 10% 30%)", border: "hsl(210 10% 75%)" };
  }
}

export function syncGateStyle(gate) {
  switch ((gate || "BLOCKED").toUpperCase()) {
    case "OPEN":                return { background: "hsl(140 40% 92%)", color: "hsl(140 55% 22%)", border: "hsl(140 40% 75%)" };
    case "DISCLOSURE_REQUIRED": return { background: "hsl(40 48% 92%)",  color: "hsl(347 72% 22%)", border: "hsl(40 48% 78%)" };
    case "REVIEW_REQUIRED":     return { background: "hsl(30 60% 92%)",  color: "hsl(30 60% 30%)",  border: "hsl(30 60% 78%)" };
    case "BLOCKED":
    default:                    return { background: "hsl(0 60% 94%)",   color: "hsl(0 60% 30%)",   border: "hsl(0 60% 78%)" };
  }
}

export function humanise(s) {
  if (!s) return "—";
  return String(s).replaceAll("_", " ").toLowerCase().replace(/\b\w/g, m => m.toUpperCase());
}
